import { useDispatch } from "react-redux";
import DynamicIcon from "../DynamicIcon";
import { setModal } from "../../redux/rightModalSlice";

export default function ProductLine({ productData, index }) {
    const dispatch = useDispatch();
    const productId = productData._id || productData.id;

    // Gestisce il click sul bottone di modifica
    const handleEditClick = (e) => {
        e.stopPropagation();
        dispatch(setModal({
            mode: 'edit',
            id: productId
        }));
    };

    // Gestisce il click sul bottone di visualizzazione
    const handleViewClick = (e) => {
        e.stopPropagation();
        dispatch(setModal({
            mode: 'view',
            id: productId
        }));
    };

    // Gestisce il click sul bottone di preview e-commerce
    const handlePreviewClick = (e) => {
        e.stopPropagation();
        dispatch(setModal({
            mode: 'preview',
            id: productId
        }));
    };

    // Gestisce il click sull'intera riga
    const handleRowClick = () => {
        dispatch(setModal({
            mode: 'view',
            id: productId
        }));
    };

    // Formatta il prezzo di vendita
    const formatPrice = (price) => {
        if (price === undefined || price === null) return "--";
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(price);
    };

    // Calcola la quantità totale dalle varianti
    const calculateTotalQuantity = () => {
        if (!productData.variants || productData.variants.length === 0) {
            return productData.quantity || 0;
        }
        
        return productData.variants.reduce((total, variant) => {
            return total + (parseFloat(variant.quantity) || 0);
        }, 0);
    };
    
    return (
        <div
            className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} w-full flex justify-between cursor-pointer hover:bg-gray-100 rounded-lg`}
            onClick={handleRowClick}
        >
            {/* Codice */}
            <div className="px-4 py-4 w-[10%] truncate">
                <div className="font-semibold">{productData.code || "--"}</div>
                {productData.variants && productData.variants.length > 0 && (
                    <div className="text-xs text-gray-500">{productData.variants.length} varianti</div>
                )}
            </div>

            {/* Descrizione */}
            <div className="px-4 py-4 w-[18%] truncate">
                {productData.title || "--"}
            </div>

            {/* Categoria */}
            <div className="px-4 py-4 w-[12%] truncate">
                {productData.categoryName || "--"}
            </div>

            {/* Fornitore */}
            <div className="px-4 py-4 w-[12%] truncate text-gray-600">
                {productData.supplierLabel || "--"}
            </div>

            {/* Prezzo Acquisto */}
            <div className="px-4 py-4 w-[10%] text-right truncate">
                {formatPrice(productData.purchasePrice)}
            </div>

            {/* Markup */}
            <div className="px-4 py-4 w-[6%] text-right truncate text-gray-500">
                {productData.markup ? `${productData.markup}%` : '--'}
            </div>

            {/* Prezzo Vendita */}
            <div className="px-4 py-4 w-[10%] text-right truncate font-medium">
                {formatPrice(productData.sellPrice)}
            </div>

            {/* Quantita' */}
            <div className="px-4 py-4 w-[8%] truncate text-right">
                {calculateTotalQuantity()}
            </div>

            {/* Bottoni Azioni */}
            <div className="px-4 py-4 w-[14%] flex justify-end items-center space-x-2">
                <button
                    className="p-1 hover:bg-purple-100 rounded-full"
                    onClick={handlePreviewClick}
                    title="Anteprima"
                >
                    <DynamicIcon iconClass="fa-solid fa-eye" />
                </button>
                <button
                    className="p-1 hover:bg-blue-100 rounded-full"
                    onClick={handleEditClick}
                    title="Modifica"
                >
                    <DynamicIcon iconClass="fa-solid fa-edit" />
                </button>
            </div>
        </div>
    );
}
